import Vue from "vue";
import Router from "vue-router";
import Inicio from "@/pages/Inicio";
import Registro from "@/pages/Registro";
import OlvidoContrasena from "@/pages/OlvidoContrasena";
import ClaveUnica from "@/pages/ClaveUnica";
import ClaveUnicaError from "@/pages/ClaveUnicaError";
import UsuarioNoRegistrado from "@/pages/UsuarioNoRegistrado";
import RecuperarContrasena from "@/pages/RecuperarContrasena";

Vue.use(Router);

const router = new Router({
  base: CONTEXT,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Inicio",
      component: Inicio
    },
    {
      path: "/registro",
      name: "Registro",
      component: Registro
    },
    {
      path: "/olvido-contrasena",
      name: "OlvidoContrasena",
      component: OlvidoContrasena
    },
    {
      path: "/recuperar-contrasena/:id",
      name: "RecuperarContrasena",
      component: RecuperarContrasena
    },
    {
      path: "/vitrina",
      name: "Vitrina",
      beforeEnter() {
        location.href = PLATAFORMA.VITRINA;
      }
    },
    {
      path: "/postulacion",
      name: "Postulacion",
      beforeEnter() {
        location.href = PLATAFORMA.POSTULACION;
      }
    },
    {
      path: "/resultados",
      name: "Resultados",
      beforeEnter() {
        location.href = PLATAFORMA.RESULTADOS;
      }
    },
    {
      path: "/ayuda-oficina-regional",
      name: "AyudaRegional",
      beforeEnter() {
        location.href = PLATAFORMA.AYUDA_OFIC_REGIONAL;
      }
    },
    {
      path: "/postulacion-finalizada",
      name: "PostulacionFinalizada",
      beforeEnter() {
        location.href = PLATAFORMA.POSTULACION_FINALIZADA;
      }
    },
    {
      path: "/clave-unica",
      name: "ClaveUnica",
      component: ClaveUnica
    },
    {
      path: "/clave-unica-error",
      name: "ClaveUnicaError",
      component: ClaveUnicaError
    },
    {
      path: "/usuario-no-registrado",
      name: "UsuarioNoRegistrado",
      component: UsuarioNoRegistrado
    },
    {
      path: "*",
      component: Inicio
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js